module.exports = "<div>\n\t<div class=\"mya-section-info disable-account\">\n\t\t<div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.my_account.data_settings.disable_account_title\"></div>\n\t\t<div class=\"text-m mt5 text-grey-3\" translate=\"cw.my_account.data_settings.disable_account_desc\" translate-values=\"{brandname : brandName, linktext : linkText, href : href}\"></div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/my-account/data-settings/disable-account/disable-account.html
// module id = FJvE
// module chunks = 0